// extracted by mini-css-extract-plugin
export var aiStarIcon = "_mh-2";
export var container = "_mh-4";
export var dismissButton = "_mh-3";
export var hasPaddingBottom = "_mh-6";
export var last = "_mh-e";
export var scrollbarThumb = "_mh-c";
export var scrollbarTrack = "_mh-b";
export var selected = "_mh-9";
export var spin = "_mh-1";
export var spinning = "_mh-0";
export var suggestionItem = "_mh-d";
export var suggestionsPanel = "_mh-5";
export var tonePill = "_mh-8";
export var tonesContainer = "_mh-7";
export var unselected = "_mh-a";